import { render, staticRenderFns } from "./Subventionsabrechnungen.vue?vue&type=template&id=33a25f8e&"
import script from "./Subventionsabrechnungen.vue?vue&type=script&lang=js&"
export * from "./Subventionsabrechnungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports